<template>
  <page-outline :title="$t('Webheader.message_format_list')">
    <template slot="pageContent">

      <div class="listPage overflow-hidden">
        <b-row class="justify-content-start px-0 mx-0 no-gutters">
          <b-button class="btn btnFilter" :disabled="activateSpinner"
            @click="onRefresh()">
            <i class="fa-light fa-rotate-right fs-14px"></i>
          </b-button>
        </b-row>

        <br />

        <b-row>
          <b-col md="12">
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <b-table fixed responsive
                v-if="formatFields.length"
                class="mt-3"
                :items="formatList"
                :fields="formatFields">
              </b-table>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import PageOutline from '@/components/common/PageOutline.vue'

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'MessageList',
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
  },
  computed: {
  },
  data () {
    return {
      activateSpinner: false,
      formatList: [],
      formatFields: [
        { key: 'Name', label: this.$t('common.routing.format_name'), class: 'text-center table-condensed-phone' },
        { key: 'Description', label: this.$t('common.routing.format_description'), class: 'text-center table-condensed-phone' }
      ]
    }
  },
  created () {
    this.getFormat()

    this.$f7.initPullToRefresh()
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    getFormat () {
      this.$engine.routing.format.fetch(
        {}
      ).then(resp => {
        this.formatList = resp.data.Formats
        this.activateSpinner = false
        this.$f7.pullToRefreshDone()
      })
    },
    onRefresh (index = 1) {
      this.activateSpinner = true
      this.pageCounter = 0

      this.getFormat()

      this.$f7.pullToRefreshDone()
    }
  }
}
</script>
